import { onPath } from '../utils/path';
import Glide from '@glidejs/glide';
import { selectMany, addClass, removeClass, toggleClass, whenOlarkExists, scrollToSmooth } from '../utils/dom-utils';
import getParameterByName from '../utils/url';

var setupProPricingCTA = function(){
  var OlarkisAvailable =  false;

  whenOlarkExists(function(){
    olark('api.chat.onOperatorsAvailable', function() {
      OlarkisAvailable = true;
    });
    olark('api.chat.onOperatorsAway', function() {
      OlarkisAvailable = false;
    });
  });


  var handleClickonCTA = function(e) {
    if(OlarkisAvailable){
      olark('api.chat.sendNotificationToOperator', {
        body: "Customer wants to chat about Pro"
      });
      olark('api.box.expand');

    }else{
      if(document.location.toString().match(/pricing-pro/)){
        scrollToSmooth('call-form');
      }else {
        document.location = "/pricing-pro?scroll-to=call-form"
      }
    }
    return false;
  }

  const olarkProCTA = selectMany('.olark-pro-pricing-contact-cta');
  olarkProCTA.forEach(function (el, i) {
    el.href = "javascript:void(0)";
    el.addEventListener('click', handleClickonCTA);
  });


};


onPath('/plan-pricing', () => {
  whenOlarkExists(function() {
    olark.configure("locale.chatting_title", "Let's talk Pricing");
  });

  // Show active state for desktop feature selector
  const featureCollection = selectMany('.feature-selector');

  featureCollection.forEach(function (el, i) {
    el.addEventListener('click', (evt) => {
      selectMany('.feature-selector').forEach(label => {
        removeClass(label,'feature-selector-active');
      });
      addClass(el,'feature-selector-active');
    });
  });

  setupProPricingCTA();

});

onPath('/pricing', () => {
  whenOlarkExists(function() {
    olark.configure("locale.chatting_title", "Let's talk Pricing");
  });

  // Show active state for desktop feature selector
  const featureCollection = selectMany('.feature-selector');

  featureCollection.forEach(function (el, i) {
    el.addEventListener('click', (evt) => {
      selectMany('.feature-selector').forEach(label => {
        removeClass(label,'feature-selector-active');
      });
      addClass(el,'feature-selector-active');
    });
  });

  setupProPricingCTA();
});

onPath('/pricing-pro', () => {
  // soft scroll to an element if needed
  whenOlarkExists(function() {
    olark.configure("locale.chatting_title", "Chat with us about Pro");

    var scrollToTarget = getParameterByName('scroll-to');
    scrollToSmooth(scrollToTarget);
  });

  setupProPricingCTA();
});